<template>
  <transition appear name="fade">
    <nav :style="{ backgroundColor }" v-show="visible" @mouseleave="hide()" :class="{ fixed: this.isFixed }">
      <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
        <div class="row">
          <ul @click="hide()">
            <li><a href="/#releases" v-smooth-scroll="{ duration: 1500 }" :style="{ color: textColor }">Releases</a></li>
                     <li><a href="/radio/" @click="radioLink($event)" :style="{ color: textColor }">Radio</a></li>
            <li><a href="https://musicalfreedom.lnk.to/ADE2018WE" :style="{ color: textColor }" target="_blank">Shows</a></li>
          </ul>
        </div>
      </div>
      <button @click="hide()" class="close" :style="{ fill: closeColor }" v-html="closeSVG"></button>
    </nav>
  </transition>
</template>

<script>
import closeSVG from '../../static/images/close.svg'
export default {
  name: 'Menu',
  dependencies: ['DATA'],
  props: ['fixed', 'login'],
  data () {
    let playlist = this.DATA.configs.radio.playlist.split('spotify:user:')[1].split(':playlist:')
    return {
      shopLink: this.DATA.configs.store.link,
      visible: this.fixed,
      backgroundColor: '#fff',
      textColor: '#000',
      closeColor: '#000',
      closeSVG: closeSVG,
      isFixed: false,
      playlistUrl: `https://open.spotify.com/user/${playlist[0]}/playlist/${playlist[1]}`
    }
  },
  methods: {
    onClickShopping () {
      fbq('track', 'clickShopping');
    },
    radioLink (event) {
      if (event) event.preventDefault()

      if (this.$browser.name === 'safari' || this.$mobileDetect.mobile()) {
        window.open(this.playlistUrl, '_blank')
        return this.$router.push({ name: 'Home' })
      }

      if (this.$storage.get('spotifyAccessToken') === null) {
        this.login(() => {
          window.location.href = '/radio'
        })
      } else {
        this.$router.push({ name: 'Radio' })
      }
    },
    hide () {
      if (this.fixed) {
        return
      }
      this.visible = false
      this.$bus.$emit('menuVisible', this.visible)
    },
    show () {
      if (this.fixed) {
        return
      }
      this.visible = true
      this.$bus.$emit('menuVisible', this.visible)
    },
    onScroll () {
      this.hide()
    }
  },
  destroyed () {
    document.removeEventListener('onscroll', this.onScroll)
  },
  mounted () {
    this.$bus.$on('showMenu', () => {
      this.show()
      this.visible = true
    })
    this.$bus.$on('setColors', (color1, color2, textColor) => {
      this.backgroundColor = color1
      this.closeColor = color2
      this.textColor = textColor
    })
    this.$bus.$on('holdScreen', () => {
      this.isFixed = true;
    })
    this.$bus.$on('releaseScreen', () => {
      this.isFixed = false;
    })
    document.addEventListener('onscroll', this.onScroll)
  }
}
</script>

<style scoped lang="scss">
@import '../scss/variables';
@import '../scss/easing';
nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    &.fixed {
      display: none;
    }

    .close {
      display: none;
      cursor: pointer;
      border: none;
      outline: none;
      position: absolute;
      background-color: transparent;
      width: 41px;
      height: 41px;

      left: 5%;
      top: 50%;
      margin-left: -17px;
      margin-top: -7px;
    }
    ul {
      display: block;
      margin: 20px auto 20px;
      li {
        display: inline-block;
        margin: 0 40px;
        a {
          text-decoration: none;
          display: block;
          position: relative;
          &:after {
            content: "";
            height: 2px;
            background: #000;
            position: relative;
            width: 100%;
            display: block;
            margin-top: 2px;
            transform: scaleX(0);
            transition: transform 0.4s $easeInOutQuint;
          }
          &:hover {
            // text-decoration: underline;
            &:after {
              transform: scaleX(1);
            }
          }
        }
      }
    }
}
@media screen and (max-width: 64em) {
  nav{
    .close {
      display: block;
    }
    ul {
      margin-top: 40px;
      li {
        margin: 0 10px;
        a {
          font-size: 16px;
        }
      }
    }
  }
}
.fade-enter-active {
  transition: transform .5s $authenticMotion;
}
.fade-leave-active {
  transition: transform .2s $authenticMotion;
}
.fade-enter, .fade-leave-to {
  transform: translateY(-70px);
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue